module.exports = __webpack_public_path__ + "static/media/052-Legends Neighbourhood Pub.4c940b8d.jpeg";